import {
  MORAL_GET, MORAL_GET_FAILURE, MORAL_GET_SUCCESS,
  MORAL_UPDATE, MORAL_UPDATE_FAILURE, MORAL_UPDATE_SUCCESS,
  MORAL_ALL_ANSWERED, MORAL_ALL_ANSWERED_FAILURE, MORAL_ALL_ANSWERED_SUCCESS,
  MORAL_END, MORAL_END_FAILURE, MORAL_END_SUCCESS,
  MESSAGE_SEND, MESSAGE_SEND_FAILURE, MESSAGE_SEND_SUCCESS,
  MORAL_NOANSWER_LIST, MORAL_NOANSWER_LIST_FAILURE, MORAL_NOANSWER_LIST_SUCCESS,
  RESULT_SEND, RESULT_SEND_FAILURE, RESULT_SEND_SUCCESS
} from './mutation-types'

export default {
  state: {
    moralResult: null,
    moralDetails: null,
    moralNoanswers: null,
    lastCount: 0
  },
  getters: {
    moralResult: state => {
      return state.moralResult
    },
    moralDetails: state => {
      return state.moralDetails
    },
    moralLastCount: state => {
      return state.lastCount
    },
    moralNoanswers: state => {
      return state.moralNoanswers
    }
  },
  actions: {
    [MORAL_GET] ({dispatch, state, commit}, params) {
      var url = '/asovi/morals/' + params.id
      var data = {}
      var callback = null
      data = params.data
      if (data) {
        callback = params.callback
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MORAL_GET_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(MORAL_GET_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [MORAL_UPDATE] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var url = '/asovi/morals/' + params.id
      dispatch('apiPatch', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MORAL_UPDATE_FAILURE, res.data)
          } else {
            commit(MORAL_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [MORAL_ALL_ANSWERED] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var url = '/asovi/morals/all_answered'
      dispatch('apiPatch', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MORAL_ALL_ANSWERED_FAILURE, res.data)
          } else {
            commit(MORAL_ALL_ANSWERED_SUCCESS, { data: res.data })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [RESULT_SEND] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var url = '/asovi/morals/result_send'
      dispatch('apiPatch', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(RESULT_SEND_FAILURE, res.data)
          } else {
            commit(RESULT_SEND_SUCCESS, { data: res.data })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [MORAL_END] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var url = '/asovi/morals/ended'
      dispatch('apiPatch', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MORAL_END_FAILURE, res.data)
          } else {
            commit(MORAL_END_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [MESSAGE_SEND] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var url = '/asovi/morals/message_send'
      dispatch('apiPatch', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MESSAGE_SEND_FAILURE, res.data)
          } else {
            commit(MESSAGE_SEND_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [MORAL_NOANSWER_LIST] ({dispatch, state, commit}, params) {
      var url = '/asovi/morals/noanswer_list'
      var data = {}
      var callback = null
      data = params.data
      if (data) {
        callback = params.callback
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MORAL_NOANSWER_LIST_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(MORAL_NOANSWER_LIST_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [MORAL_GET_FAILURE] (state, data) {
      console.log('MORAL_GET_FAILURE')
    },
    [MORAL_GET_SUCCESS] (state, data) {
      console.log('MORAL_GET_SUCCESS')
      state.moralResult = data.moral_result.data
      state.moralDetails = data.moral_detail.data

      if (data.last_count) {
        state.lastCount = data.last_count.display_order
      } else {
        state.lastCount = 0
      }
      if (data.callback) {
        data.callback()
      }
    },
    [MORAL_UPDATE_FAILURE] (state, data) {
      console.log('MORAL_UPDATE_FAILURE')
    },
    [MORAL_UPDATE_SUCCESS] (state, data) {
      console.log('MORAL_UPDATE_SUCCESS')
      if (data.callback) {
        data.callback()
      }
    },
    [MORAL_ALL_ANSWERED_FAILURE] (state, data) {
      console.log('MORAL_ALL_ANSWERED_FAILURE')
    },
    [MORAL_ALL_ANSWERED_SUCCESS] (state, data) {
      console.log('MORAL_ALL_ANSWERED_SUCCESS')
    },
    [RESULT_SEND_FAILURE] (state, data) {
      console.log('RESULT_SEND_FAILURE')
    },
    [RESULT_SEND_SUCCESS] (state, data) {
      console.log('RESULT_SEND_SUCCESS')
    },
    [MORAL_END_FAILURE] (state, data) {
      console.log('MORAL_END_FAILURE')
    },
    [MORAL_END_SUCCESS] (state, data) {
      console.log('MORAL_END_SUCCESS')
      if (data.callback) {
        data.callback()
      }
    },
    [MESSAGE_SEND_FAILURE] (state, data) {
      console.log('MESSAGE_SEND_FAILURE')
    },
    [MESSAGE_SEND_SUCCESS] (state, data) {
      console.log('MESSAGE_SEND_SUCCESS')
      if (data.callback) {
        data.callback()
      }
    },
    [MORAL_NOANSWER_LIST_FAILURE] (state, data) {
      console.log('MORAL_NOANSWER_LIST_FAILURE')
    },
    [MORAL_NOANSWER_LIST_SUCCESS] (state, data) {
      console.log('MORAL_NOANSWER_LIST_SUCCESS')
      state.moralNoanswers = data.data
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/moral.js